import React from 'react'
import './_MatchDetailStatsEmpty.scss'

/**
 * MatchDetailStatsEmpty
 *
 * Estado vacío del tab de Estadísticas.
 * Se muestra cuando el mock/API no provee datos (null, undefined o array vacío).
 * Figma: PDX_Large-Focus_Mundial-2026_Fase2 — node 87:17147 "Large/Tablas/Posesion"
 *
 * Muestra las 14 estadísticas estándar con valores en 0 y barras en gris (#979797).
 * Layout: position absolute/relative + inline-block. Sin flex ni grid.
 */

var EMPTY_ROWS = [
  { label: 'Tiros totales',      leftValue: '0',  rightValue: '0'  },
  { label: 'Tiros a portería',   leftValue: '0',  rightValue: '0'  },
  { label: 'Tiros fuera',        leftValue: '0',  rightValue: '0'  },
  { label: 'Tiros bloqueados',   leftValue: '0',  rightValue: '0'  },
  { label: 'Paradas del portero',leftValue: '0',  rightValue: '0'  },
  { label: 'Tarjetas rojas',     leftValue: '0',  rightValue: '0'  },
  { label: 'Tarjetas amarillas', leftValue: '0',  rightValue: '0'  },
  { label: 'Faltas cometidas',   leftValue: '0',  rightValue: '0'  },
  { label: 'Faltas ganadas',     leftValue: '0',  rightValue: '0'  },
  { label: 'Pases totales',      leftValue: '0',  rightValue: '0'  },
  { label: 'Precisión de pases', leftValue: '0%', rightValue: '0%' },
  { label: 'Saques de esquina',  leftValue: '0',  rightValue: '0'  },
  { label: 'Fuera de juego',     leftValue: '0',  rightValue: '0'  }
]

var MatchDetailStatsEmpty = function () {
  return (
    <div className='match-detail-stats-empty'>

      {/* ── Fila especial: Posesión ── */}
      <div className='match-detail-stats-empty__row match-detail-stats-empty__row--posesion'>
        <span className='match-detail-stats-empty__value match-detail-stats-empty__value--left'>
          0%
        </span>
        <span className='match-detail-stats-empty__label match-detail-stats-empty__label--posesion'>
          Posesión
        </span>
        <span className='match-detail-stats-empty__value match-detail-stats-empty__value--right'>
          0%
        </span>
        <span className='match-detail-stats-empty__bar' />
      </div>

      {/* ── Filas estándar ── */}
      {EMPTY_ROWS.map(function (row, index) {
        return (
          <div key={row.label + '-' + index} className='match-detail-stats-empty__row'>
            <span className='match-detail-stats-empty__value match-detail-stats-empty__value--left'>
              {row.leftValue}
            </span>
            <span className='match-detail-stats-empty__label'>
              {row.label}
            </span>
            <span className='match-detail-stats-empty__value match-detail-stats-empty__value--right'>
              {row.rightValue}
            </span>
            <span className='match-detail-stats-empty__bar' />
          </div>
        )
      })}
    </div>
  )
}

export default MatchDetailStatsEmpty



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/FootballMatchDetail/Components/MatchDetailStatsEmpty/MatchDetailStatsEmpty.jsx